import { createRequestInterceptor, errorInterceptor, getRootApiUrl } from "@/lib/apiConfig";
import { attachAuthRefreshInterceptor } from "@/lib/authSession";
import axios from "axios";

/** pbx-api, the app plane (NEXT_PUBLIC_API_URL, :8793 locally). Same wiring as sipClient, only the
 *  base URL differs. Not a shared factory module: apiConfig → authStore → apiClient → these clients
 *  is an import cycle, and a factory module caught mid-cycle is not initialised yet. */
export const pbxClient = axios.create();
pbxClient.interceptors.request.use(createRequestInterceptor(getRootApiUrl));
// Order matters: the shared 401 refresh-and-retry handler must run BEFORE the shared error
// interceptor so a successful silent refresh short-circuits the isUnauthorized→logout path.
attachAuthRefreshInterceptor(pbxClient);
pbxClient.interceptors.response.use(undefined, errorInterceptor);
